import React, { useEffect, useState } from "react";
import { AddButtonContainer, StyledContainer } from "./Style";
import type { ColumnsType, TableProps } from 'antd/es/table';
import { Table, Button, Space } from 'antd';
import Spinner from "../Spinner";
import { FileExcelFilled, PrinterFilled } from '@ant-design/icons';
import { errorNotify, sucessNotify } from "../../../services/toast.notification";
import { ExportToCsv } from 'export-to-csv';
import toast from 'react-hot-toast';

export interface InputProps {
    title?: string;
    columns: ColumnsType<any>
    data: any,
    isloading: Boolean;
    onChange?: any,
    onSort?: any,
    onFilter?: any,
    onAddClick?: any,
    addButtonTitle?: any,
    expandedRowRender?: any[],
    permission?: any
}


const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    title: 'گزارش از سیستم پارسی پل',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: " "
    // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
};

const RequestPayTable = ({ columns, data, isloading, onAddClick, addButtonTitle = 'جدید', expandedRowRender, permission }: InputProps) => {
    const [height, setHeight] = useState(300);

    const company_columns = [
        { title: "نام مشتری", dataIndex: "str_CustomerName" },
        { title: "شناسه ملی", dataIndex: "str_NationalCode" },
        { title: "نام مدیرعامل", dataIndex: "str_CEOName" },
        { title: "کدملی مدیرعامل", dataIndex: "str_CEONationalCode" },
        { title: "تاریخ تولد", dataIndex: "str_BrithDay" },
        { title: "شماره شناسنامه", dataIndex: "str_Identityid" },
        { title: "سریال شناسنامه", dataIndex: "str_Identityserialnumber" },
        { title: "نام پدر", dataIndex: "str_fatherName" },
        { title: "شماره ثبت", dataIndex: "str_Registrationnumber" },
        { title: "تاریخ ثبت شرکت", dataIndex: "str_Companyregistrationdate" },
        { title: "شهر", dataIndex: "str_StateName" },
        { title: "تلفن ثابت ", dataIndex: "str_DirectTel" },
        { title: "موبایل", dataIndex: "str_MobileNumber" },
        { title: "ایمیل", dataIndex: "str_Email" },
        { title: "نام صاحب حساب", dataIndex: "str_Accountownername" },
        { title: "نام بانک", dataIndex: "str_Bank" },
        { title: "شماره حساب", dataIndex: "str_Accountnumber" },
        { title: "شماره شبا", dataIndex: "str_Shaba" },


    ];

    const _columns = [
        { title: "نام و نام خانوادگی", dataIndex: "str_CustomerName" },
        { title: "کد ملی", dataIndex: "str_NationalCode" },
        { title: "تاریخ تولد", dataIndex: "str_BrithDay" },
        { title: "شماره شناسنامه", dataIndex: "str_Identityid" },
        { title: "سریال شناسنامه", dataIndex: "str_Identityserialnumber" },
        { title: "نام پدر", dataIndex: "str_fatherName" },
        { title: "شهر", dataIndex: "str_StateName" },
        { title: "تلفن ثابت ", dataIndex: "str_DirectTel" },
        { title: "موبایل", dataIndex: "str_MobileNumber" },
        { title: "ایمیل", dataIndex: "str_Email" },
        { title: "نام صاحب حساب", dataIndex: "str_Accountownername" },
        { title: "نام بانک", dataIndex: "str_Bank" },
        { title: "شماره حساب", dataIndex: "str_Accountnumber" },
        { title: "شماره شبا", dataIndex: "str_Shaba" },


    ];

    useEffect(() => {

        if (window.innerHeight - 200 > 300) {
            setHeight(window.innerHeight - 200)
        }
    }, [])

    const exportToExcell = () => {
        let toastId: any;
        if (!data) {
            errorNotify("داده ای جهت خروجی وجود ندارد");
            return;
        }

        toastId = toast.loading('...درحال آماده سازی فایل فاکتور');
        data.forEach((item: any, index: number) => {

            options.filename = item.str_LabPersianName;
            const csvExporter = new ExportToCsv(options);

            if (item.frk_ApproveUserId == 0 && item.bit_IsCompany) {
                let res: Array<any> = new Array<any>;
                let row = { ["ردیف"]: 1 };

                //console.log(item);
                company_columns.forEach((col: any) => {
                    if (col.title != "" && col.title != "-")
                        if (item[col.dataIndex] === null)
                            row = { ...row, [col.title]: "" }
                        else
                            row = { ...row, [col.title]: item[col.dataIndex].toString().replaceAll("/", "") }


                });
                res.push(row);
                csvExporter.generateCsv(res);

            }
            else if (item.frk_ApproveUserId == 0 && !item.bit_IsCompany) {
                let res: Array<any> = new Array<any>;
                let row = { ["ردیف"]: 1 };

                console.log(item);
                _columns.forEach((col: any) => {
                    if (col.title != "" && col.title != "-")
                        if (item[col.dataIndex] === null)
                            row = { ...row, [col.title]: "" }
                        else
                            row = { ...row, [col.title]: item[col.dataIndex].toString().replaceAll("/", "") }


                });
                res.push(row);
                csvExporter.generateCsv(res);

            }

        });


        toast.dismiss(toastId);
        sucessNotify("فایل های خروجی با موفقیت ساخته شدند.");

    }

    const print = () => {
        errorNotify("این گزینه در حال حاضر غیر فعال می باشد")
    }



    const showDecData = (r: any, i: any) => {
        if ((expandedRowRender != undefined) && expandedRowRender.length > 0) {

            return expandedRowRender.map((item) =>

                <p style={{ margin: 0, textAlign: 'right', fontSize: '13px', borderBottom: '1px solid #c3c0c0', padding: '3px 0px' }}>

                    <span style={{ display: 'inline-block', padding: '0px 10px', color: '#252525', fontWeight: 'bold' }}>
                        {[item.title]}
                        :
                    </span>
                    <span style={{ color: '##353535' }}>
                        {r[item.val]}
                    </span>

                </p>
            );

        }
        else
            return ''
    }
    const [activeExpRow, setActiveExpRow] = React.useState();

    const onExpand = (expanded: any, record: any) => {
        const keys: any = [];
        debugger
        if (expanded) {
            // keys.push(record.index);
            keys.push(record.id);
        }
        console.log(keys);
        setActiveExpRow(keys);
    }
    const rowExpandabl = (r: any) => {
        return true
    }
    return (
        <StyledContainer>

            {isloading === false && onAddClick !== undefined && (
                <AddButtonContainer>
                    <Button type="primary" style={{ backgroundColor: "Green" }} onClick={onAddClick} disabled={!permission}>{addButtonTitle}</Button>
                </AddButtonContainer>
            )}

            {isloading === false && (
                <>
                    {permission && (<><FileExcelFilled  style={{ color: 'Green', fontSize: '18px', marginRight: '6px' }} onClick={exportToExcell} />
                        {/* <PrinterFilled style={{ color: 'Blue', fontSize: '18px', marginRight: '6px' }} onClick={print} /> */}
                        </>)}
                    
                    {window.matchMedia('(max-width: 1023px)').matches && (
                        <Table scroll={{ x: 1500 }} dataSource={data} columns={columns}
                            expandable={{
                                expandedRowRender: (record: any, i) =>
                                    showDecData(record, i)
                            }}
                            onExpand={onExpand}
                            expandedRowKeys={activeExpRow}

                        />
                    )}
                    {!window.matchMedia('(max-width: 1023px)').matches && (
                        <Table scroll={{ x: 1500 }}
                            dataSource={data} columns={columns}

                        />
                    )}
                </>
            )}

            {isloading === true && (
                <Spinner />
            )}

        </StyledContainer>
    )

};

export default RequestPayTable;
